import { render } from "./RoutingFirewallRulesTab.vue?vue&type=template&id=3b28d9ca&scoped=true"
import script from "./RoutingFirewallRulesTab.vue?vue&type=script&lang=js"
export * from "./RoutingFirewallRulesTab.vue?vue&type=script&lang=js"

import "./RoutingFirewallRulesTab.vue?vue&type=style&index=0&id=3b28d9ca&scoped=true&lang=scss"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.21.0.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b28d9ca"]])

export default __exports__